// util function (no hooks here)
export const getScore = (score: number, options: { value: string, display_text: string }[]) => {
    const mapping: Record<number, string> = {
        1: "very_low",
        2: "low",
        3: "medium",
        4: "high",
        5: "very_high"
    };

    const key = mapping[score];
    if (!key) return "N/A";

    return options.find((s) => s.value === key)?.value || "N/A";
};